export const checkIsFullscreen = (element) =>
  (document.fullscreenElement ||
    document.webkitFullscreenElement ||
    document.mozFullScreenElement ||
    document.msFullscreenElement) === element;
